import styled from "styled-components";
import logoalt from "../../../icons/logoalt.svg";
import headerAlarm from "../../../icons/headerAlarm.svg";
import user from "../../../icons/user.svg";
import { UIWidgetsDiv } from "../division/Division";

const UIWidgetsHeader = styled(UIWidgetsDiv)`
  font: inherit;
  position: relative;
  min-height: ${(props)=> props.isAsset ? props.theme.height50 : props.theme.minHeight74};
  align-items: center;
  font-size: ${props => props.theme.font18};
  border-bottom: 1px solid ${props => props.theme.borderLightGrey};
`;

export const UIWidgetsLogo = styled.div`
  background-image: url(${logoalt});
  width: 142px;
  height: 39px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: ${props => props.theme.margin24};
`;

export const UIWidgetsBreadcrumb = styled(UIWidgetsDiv)`
  color: ${props => props.theme.hexGray575757};
  font-family: ${props => props.theme.font_family};
  font-size: ${props => props.theme.font18};
  font-weight: bold;
  opacity: 0.87;
  line-height: ${props => props.theme.lineHeight18};
  margin-left: ${props => props.theme.margin24};
`;

export const UIWidgetsAlarm = styled.div`
  background-image: url(${headerAlarm});
  width: 18px;
  height: 18px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: 24px;
`;

export const UIWidgetsUser = styled.div`
  background-image: url(${user});
  width: 28px;
  height: 28px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: 24px;
`;

export const UIWidgetsHeaderRightWrapper = styled(UIWidgetsDiv)`
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

export default UIWidgetsHeader;
